import React from 'react'
import { Button, CircularProgress, Typography, Box } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import useStyles from './style';
import { chatRedirect } from '../../utils';

const FooterViewer = (props) => {
    const { saveData, isUpdated, listPages, belowThresholdError } = props;
    const { chartUniqueId } = props.data || {};
    const classes = useStyles();
    const isLoading = props.formData?.[chartUniqueId + '_update_loading'] || props.formData?.[chartUniqueId + '_save_loading'] ||  false;
    
    return (
        <div className={classes.wrapper}>
            {belowThresholdError && (
                <Box className={classes.thresholdErrorBox} role="alert">
                    <div className={classes.thresholdErrorAccent} />
                    <div className={classes.thresholdErrorContent}>
                        <div className={classes.thresholdErrorTitleRow}>
                            <BlockIcon className={classes.thresholdErrorIcon} />
                            <Typography variant="subtitle2" className={classes.thresholdErrorTitle}>
                                {belowThresholdError.title}
                            </Typography>
                        </div>
                        <Typography variant="body2" className={classes.thresholdErrorMessage}>
                            {belowThresholdError.message}
                        </Typography>
                    </div>
                </Box>
            )}
            <div className={classes.root}>
                <Button variant="contained" className={classes.cancelButton} onClick={() => { chatRedirect(props.history, props.match.params.appid, listPages) }}>Cancel</Button>
                {isLoading ? (
                    <div className={classes.loaderContainer}>
                        <CircularProgress size={24} className={classes.loader} />
                    </div>
                ) : (
                    <Button 
                        variant="contained" 
                        className={classes.saveButton} 
                        onClick={() => { saveData() }}
                    >
                        {isUpdated ? 'Update' : 'Save'}
                    </Button>
                )}
            </div>
        </div>
    )
}

export default FooterViewer
